import React, { Component } from 'react';
import { SimpleForm, TextInput, Toolbar, SaveButton, translate } from 'react-admin';
import FieldGroup from '~components/FieldGroup';
import { isRequired } from '~utils/inputValidations';

function EstadoToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
}

class EstadoForm extends Component {
  render() {
    return (
      <SimpleForm {...this.props} toolbar={<EstadoToolbar />}>
        {this.props.children}
        <FieldGroup label="fieldGroups.estadoEs">
          <TextInput source="name" validate={isRequired} />
        </FieldGroup>
        <FieldGroup label="fieldGroups.estadoEn">
          <TextInput source="nameEn" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.estadoPt">
          <TextInput source="namePt" />
        </FieldGroup>
      </SimpleForm>
    );
  }
}

export default translate(EstadoForm);
